import { Group, Path as PathKonva } from "react-konva";
import { useMemo } from "react";
import { PositionInTrain, getUnitPoints } from "../core/planTrainUnitUnitCalculations";
import { PlanTrainUnitUnitEndShape } from "./PlanTrainUnitUnitEndShape";
import { PointHelper } from "@opstel/geo/helpers/PointHelper";
import { Point } from "@opstel/geo/Point";

type PlanTrainUnitUnitProps = {
  readonly fill: string;
  readonly points: Point[];
  readonly position: PositionInTrain;
  readonly width: number;
};

export const PlanTrainUnitUnit = ({ fill, points, position, width }: PlanTrainUnitUnitProps) => {
  const unitPoints = useMemo(
    () => getUnitPoints(points, position, width),
    [points, position, width],
  );

  return (
    <Group>
      <PathKonva
        data={PointHelper.toDataString(unitPoints)}
        stroke={fill}
        strokeWidth={width}
        lineJoin="round"
      />
      {position !== "middle" && (
        <PlanTrainUnitUnitEndShape
          points={unitPoints}
          fill={fill}
          width={width}
          position={position}
        />
      )}
    </Group>
  );
};
